import React from 'react'
import intl from 'react-intl-universal'
import { Link } from '@raysync/common/components'
import styled, { css } from 'styled-components'
import CmsContentService from '../../services/cms-content-service'
import ArrowRight from '@raysync/common/components/svg/smb/arrow-3'
import { multiLineTextEllipsis, Media } from '@raysync/common/theme'
import { Navigation } from '@raysync/common/services'
import { useMedia } from '@raysync/common/hooks'
const formatDate = d => {
  let date = new Date(d)
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}
const colorMap = {
  'raysync-news': {
    bg: '#FFEBE3',
    color: '#FD5C1F',
  },
  'transfer-questions': {
    bg: '#E5FCFF',
    color: '#009EB6',
  },
  'user-guide': {
    bg: '#E1FFE8',
    color: '#009EB6',
  },
  'case-studies': {
    bg: '#F3E7FF',
    color: '#8000FF',
  },
  'industry-news': {
    bg: '#E2EBFF',
    color: '#0055FF',
  },
}

const ContentBox = styled.div`
  overflow-y: hidden;
  div a {
    color: #252a3a;
    line-height: 1.3;
    font-size: 24px;
    font-weight: bold;
    margin: 4px 0;
    ${multiLineTextEllipsis(3)};
  }
  p {
    margin-top: 4px;
    position: relative;
    font-size: 16px;
    line-height: 1.5;
    color: #636772;
    ${multiLineTextEllipsis(2)};
  }
  ${Media.phone`
    height: unset;
    max-height: unset;
    div a {
      font-size: .4rem;
      margin: 0;
    }
    p {
      font-size: .28rem;
      margin-top: .2rem;
      -webkit-line-clamp: ${4} !important;
    }
  `}
`
const CardItem = styled.div`
  position: relative;
  width: 380px;
  height: 520px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(99, 103, 114, 0.15);
  border-radius: 10px;
  margin-top: 30px;

  img {
    width: 100%;
    height: 220px;
    border-radius: 10px 10px 0px 0px;
    cursor: pointer;
  }
  > div {
    padding: 12px 22px 14px;

    > a {
      position: absolute;
      bottom: 20px;
      display: flex;
      margin-top: 2px;
      font-weight: 700;
      color: ${p => p.theme.color.secondary};
      svg {
        width: 18px;
        margin-left: 4px;
        transform: translateY(1px);
        path {
          fill: currentColor;
        }
      }
    }
  }
  ${p =>
    p.isHotCard &&
    css`
      height: 465px;
      background-color: transparent;
      box-shadow: unset;
      border-radius: 10px;
      transition: all 0.3s linear;
      padding: 20px;
      img {
        width: 100%;
        height: 200px;
        border-radius: 10px;
      }
      > div {
        padding-left: 0;
        padding-right: 0;
        > a {
          bottom: 30px;
          color: #333;
        }
      }
      ${ContentBox} {
        div a {
          ${multiLineTextEllipsis(2)};
        }
      }
      :hover {
        background-color: #fff;
        box-shadow: 0px 7px 32px 0px rgba(0, 0, 0, 0.08);
        > div {
          > a {
            color: ${p => p.theme.color.secondary};
          }
        }
      }
    `}
  ${Media.phone`
    margin-top: .42rem;
    margin-right: 0 !important;
    padding-bottom: .2rem;
    width: 100%;
    height: unset;
    img {
      height: 3.72rem;
    }
    > div {
      padding: .2rem .38rem;
      a {
        position: unset;
        margin-top: .2rem;
      }
    }
      ${p =>
        p.isHotCard &&
        css`
          height: auto;
          background-color: #fff;
          padding: 0.4rem 0.4rem 0;
          img {
            width: 100%;
            max-height: 4rem;
            /* padding: 0.4rem 0.4rem 0; */
            border-radius: 0.2rem;
          }
          > div {
            padding: 0.2rem 0;
            /* padding-left: 0.4rem;
            padding-right: 0.4rem; */
            > a {
              margin-top: 0.3rem;
            }
          }
        `}
  `}
`
const CardBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  input {
    margin: 0;
    border-radius: 6px 0px 0px 6px;
    border: 1px solid #e2e5e7;
    height: 40px;
  }
  ${CardItem} {
    &:not(:nth-child(3n)) {
      margin-right: 30px;
    }
  }
`
const FirstCardItem = styled(CardItem)`
  width: 100%;
  height: 340px;
  display: flex;
  margin-top: 40px;
  margin-bottom: 10px;
  img {
    width: 588px;
    height: 100%;
    border-radius: 10px 0 0 10px;
  }
  > div {
    padding: 40px;
    > a {
      bottom: 40px;
    }
  }
  ${ContentBox} {
    h4 a {
      font-size: 30px;
    }
    p {
      margin-top: 10px;
    }
  }
`
const HotCardItem = styled(FirstCardItem)`
  height: 220px;
  margin: 0 0 30px !important;
  box-shadow: unset;
  img {
    border-radius: 6px;
    width: 380px;
    min-width: 380px;
    max-width: unset;
  }
  > div {
    padding: 20px;
    h4 a {
      font-size: 24px !important;
    }
    ${ContentBox} {
      p {
        margin-top: 0;
        font-size: 16px;
      }
    }
    > a {
      margin-top: 8px;
      position: unset;
    }
  }
`

const CategoryWrap = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 6px;
  p {
    line-height: 1;
    color: #636772;
    border-bottom: 2px solid ${p => p.theme.color.secondary};
    padding: 6px 0;
    border-top: 2px solid transparent;
  }
  b {
    display: block;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: #636772;
    margin: 0 8px;
  }
  span {
    color: #989eab;
    line-height: 1;
  }
  ${Media.phone`
    font-size: .24rem;
    margin-bottom: .18rem;
    p {
      border-width: 1px;
    }
  `}
`
const Content = ({ title, intro, slug, contentHeight = 200 }) => {
  const titleRef = React.useRef()

  return (
    <ContentBox>
      <div ref={titleRef}>
        <Link to={`/news/${slug}/`}> {title}</Link>
      </div>
      <p>{intro}</p>
    </ContentBox>
  )
}

const CardContent = ({ item, isSearchCard, contentHeight, categorySlug }) => {
  const coverImgSrc =
    item.coverImage && item.coverImage.file
      ? item.coverImage.file.url
      : isSearchCard
      ? item.imgSrc
      : CmsContentService.getCoverImg(
          item.content && item.content.content ? item.content.content : item.tinyContent.tinyContent,
        )

  const intro = isSearchCard ? item.content : item.seoDescription
  const category =
    item.categories && item.categories.length > 0
      ? categorySlug
        ? item.categories.find(i => i.slug === categorySlug)
        : item.categories[0]
      : {}
  return (
    <>
      <img
        src={coverImgSrc}
        alt={item.title}
        onClick={() => {
          Navigation.to({ link: `/news/${item.slug}/` })
        }}
      />
      <div>
        <CategoryWrap>
          {category.name && (
            <>
              <p>{category.name}</p>
              <b></b>
            </>
          )}
          <span>{formatDate(item.legacyDate || item.createdAt)}</span>
        </CategoryWrap>
        <Content slug={item.slug} title={item.title} intro={intro} contentHeight={contentHeight} />
        <Link to={`/news/${item.slug}/`}>
          {intl.get('news.read-more')} <ArrowRight />
        </Link>
      </div>
    </>
  )
}
export const HotCardList = ({ data, categorySlug }) => {
  const isMobile = useMedia()
  const sortedData = React.useMemo(() => {
    return data.sort((a, b) => new Date(b.legacyDate || b.createdAt) - new Date(a.legacyDate || a.createdAt))
  }, [])
  return (
    <CardBox>
      {sortedData.map(item =>
        isMobile ? (
          <CardItem key={item.slug}>
            <CardContent item={item} categorySlug={categorySlug} />
          </CardItem>
        ) : (
          <HotCardItem key={item.slug}>
            <CardContent item={item} contentHeight={120} categorySlug={categorySlug} />
          </HotCardItem>
        ),
      )}
    </CardBox>
  )
}
export const CardList = ({ slug, data, isSearchCard, firstPost, url, isHotCard }) => {
  const isMobile = useMedia()

  const categorySlug = React.useMemo(() => {
    if (slug) {
      return slug
    }
    if (url) {
      const match = url.match(/\/category-([\w-]*)\//)
      return match ? match[1] : undefined
    }
    return undefined
  }, [slug, url])
  return (
    <>
      {firstPost &&
        (!isMobile ? (
          <FirstCardItem>
            <CardContent item={firstPost} isSearchCard={isSearchCard} contentHeight={170} />
          </FirstCardItem>
        ) : (
          <CardItem>
            <CardContent item={firstPost} isSearchCard={isSearchCard} />
          </CardItem>
        ))}
      <CardBox>
        {data.map((item, index) => {
          return (
            <CardItem isHotCard={isHotCard} isSearchCard={isSearchCard} key={item.slug}>
              <CardContent categorySlug={categorySlug} item={item} isSearchCard={isSearchCard} isHotCard={isHotCard} />
            </CardItem>
          )
        })}
      </CardBox>
    </>
  )
}
